<template>
    <p>{{ $t('page_not_found') }}</p>
</template>

<script>
    export default {
        data: function() {
            return {};
        }
    }
</script>